import { type ComponentType, type ComponentProps, lazy, Suspense } from 'react';
import { LoadingIndicator } from 'components/loading';

const LazyComponent = <T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
) => {
  const Component = lazy(importFn);

  return (props: ComponentProps<T>) => (
    <Suspense fallback={<LoadingIndicator />}>
      <Component {...props} />
    </Suspense>
  );
};

export default LazyComponent;
